export const sliceName = 'events'

export const eventsSearchLimit = 15
